import { FuseNavigation } from '@fuse/types';

export const navigationLoggedIn: FuseNavigation[] = [
    {
        id: 'modules',
        title: '',
        translate: 'nav.app.yourModules',
        type: 'group',
        children: [
            {
                id: 'tenants',
                title: 'Deine Häfen',
                translate: 'nav.app.yourHarbours',
                type: 'item',
                icon: 'directions_boat',
                url: 'bcm/tenants'
            }
        ]
    },
    {
        id: 'links',
        title: '',
        type: 'group',
        children: [
            {
                id: 'Impressum',
                title: 'Impressum',
                translate: 'nav.app.imprint',
                type: 'item',
                url: 'https://www.up2boat.com/impressum',
                externalUrl: true,
                openInNewTab: true,
            },
            {
                id: 'Datenschutzerklärung',
                title: 'Datenschutzerklärung',
                translate: 'nav.app.privacy',
                type: 'item',
                url: 'https://www.up2boat.com/datenschutzerklaerung',
                externalUrl: true,
                openInNewTab: true,
            },
            {
                id: 'AGB',
                title: 'AGB',
                translate: 'nav.app.terms',
                type: 'item',
                url: 'https://www.up2boat.com/agb',
                externalUrl: true,
                openInNewTab: true,
            }
        ]
    }
];
